import './App.css';
import './i18n'; // Import i18n configuration
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home1 from './pages/home1';

import Home7 from './pages/home7_landscape';

import ContactPage from './pages/innerpages/contact';
import GalleryPage from './pages/innerpages/gallery';
import PortfolioPage from './pages/innerpages/portfolio';
import ProjectsPage from './pages/innerpages/project';
import FloorPage from './pages/innerpages/floor';
import ApartPage from './pages/innerpages/apart';
import TermsPage from './pages/innerpages/terms';

import SingleProject from './pages/innerpages/single_project';
import ApartmentDetails from './components/innerpage/apartament/ApartMap';


function App() {
  
  return (
     <><Helmet>
      <title>Botanicheska 302 – Нова сграда в Св. Св. Константин и Елена</title>
      <meta
        name="description"
        content="Botanicheska 302 е нова жилищна сграда в Св. Св. Константин и Елена с модерна архитектура, апартаменти с панорама, зеленина и стилно ново строителство." />
    </Helmet><Router>
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/home1" element={<Home1 />} />

          {/* //About us page */}
          <Route path="/home7_landscape" element={<Home7 />} />
          <Route path="/innerpages/contact" element={<ContactPage />} />
          <Route path="/innerpages/gallery" element={<GalleryPage />} />

          {/* Project page */}
          <Route path="/innerpages/portfolio" element={<PortfolioPage />} />
          <Route path="/innerpages/projects" element={<ProjectsPage />} />

          {/* Floors page */}
          <Route path='/innerpages/floor' element={<FloorPage />} />
          <Route path='/innerpages/apartamet-details' element={<ApartPage />} />
          <Route path="/apartments/:id" element={<ApartPage />} />
          <Route path="/innerpages/apartament-details" element={<ApartPage />} />


          {/* TermsPage */}
          <Route path="/innerpages/terms" element={<TermsPage />} />

          {/* Single apartament */}
          <Route path="/innerpages/single_project" element={<SingleProject />} />
        </Routes>
      </Router></>
  );
}

export default App;
